import Store from "App/Store.js";

export default featuresAvailable => Store.dispatch({type: "featuresAvailable", featuresAvailable});
